document.addEventListener("DOMContentLoaded", async function () {
  const storedItems = JSON.parse(localStorage.getItem("Wishlist items")) || [];
  const container = document.querySelector(".wishlist-items");
  const customerId = ShopifyAnalytics.meta?.page?.customerId || null;
  const wishlistId = localStorage.getItem("wishlistId");
//  const wishListItemsContainer = document.querySelector(".wishlist-items");
  
  if (customerId && wishlistId) {
    try {
      const res = await fetch(
        `https://oms-app.iqrupandritz.com/api/base/wishlists/${wishlistId}/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-shopify-customer-id": customerId,
          },
        }
      );

      if (!res.ok) throw new Error(`GET wishlist failed: ${res.status}`);
      const result = await res.json();
      const wishlistItems = result.wishlist_items || [];
      console.log("Fetched wishlist items:", wishlistItems);
      displayWishlist(wishlistItems);
    } catch (err) {
      console.error("Wishlist error:", err);
      displayWishlist(storedItems);
    }
  } else {
    displayWishlist(storedItems);
  }


  function displayWishlist(wishlistItems) {
    showSpinner();
    if (!wishlistItems.length) {
      container.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    wishlistItems.forEach((item) => {
      const handle = item.metadata?.handle;
      const variantId = item?.product_variant;
  
      if (handle && variantId) {
        fetchWishListData(handle, variantId);
      } else {
        console.warn("Missing handle in wishlist item:", item);
      }
    });
    hideSpinner();
  }

  async function fetchWishListData(handle, variantId) {
    try {
      const response = await fetch(`/products/${handle}?view=wishlist&variant=${variantId}`);

      if (!response.ok) throw new Error(`Failed to fetch product: ${handle}`);

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const wishlistCard = doc.querySelector(".wishlist-item");

      if (wishlistCard) {
        container.innerHTML += wishlistCard.outerHTML;
      } else {
        console.warn(`No .wishlist-item found in template for: ${handle}`);
      }
    } catch (error) {
      console.error("Error fetching wishlist card:", error);
    }
  }

  // function fetchWishListData(handle, variantId) {
  //   fetch(`/products/${handle}.js`)
  //     .then((response) => response.json())
  //     .then((product) => {
  //       hideSpinner();
  //       const variant = product.variants.find((v) => v.id === variantId);
      
  //       if (!variant) {
  //         console.error("Variant not found:", variantId);
  //         return;
  //       }
  //       const productUrl = `/products/${handle}?variant=${variant.id}`;
  //       let imageSrc = product.images[0]; 
  //      const variantMedia = product.media?.find((m) => m.id === variant.featured_media?.id && m.media_type === "image");

  //     if (variantMedia?.preview_image?.src) {
  //       imageSrc = variantMedia.preview_image.src;
  //     }
  //     const wishlistItem = document.createElement("div");
  //       wishlistItem.className = "wishlist-item";
  //       wishlistItem.innerHTML = `
  //       <a class="product-link" href="${productUrl}">
  //         <div class="image-wrapper">
  //           <img src="${imageSrc}" width="400px" alt="${variant.title }" />
  //              <button class="wishlist-remove" data-variant-id="${variant.id}">
  //               <svg
  //                 xmlns="http://www.w3.org/2000/svg"
  //                 width="21"
  //                 height="21"
  //                 class="icon icon-close-small {{ class }}"
  //                 viewBox="0 0 21 21"
  //                 fill="none"
  //               >
  //                 <path d="M10.364 8.94978L15.3138 4L16.728 5.41421L11.7782 10.364L16.728 15.3137L15.3138 16.7279L10.364 11.7782L5.41422 16.7279L4 15.3137L8.94976 10.364L4 5.41421L5.41422 4L10.364 8.94978Z" fill="black"/>
  //                 </svg>
  //               </button>
  //            </div>
  //           <div class="card__content">
  //             <h3 class="card__heading h2">${product.title}</h3>
  //             <p class="card-variant-title product-option">${variant.title}</p>
  //             <p class="price-item">Price: ${priceConverter(variant.price)}</p>
  //           </div>
  //         </a>
  //         <button class="wishlist-add-to-cart button" data-variant-id="${variant.id}">Add to cart</button>`;

  //       container?.appendChild(wishlistItem);
  //     })
  //     .catch((error) => {
  //       console.error("Error loading product:", handle, error);
  //     });
  // }

  // function priceConverter(productPrice) {
  //   // Ensure we have a valid number to format
  //   if (productPrice === null || productPrice === undefined) return "";
    
  //   const price = (productPrice / 100).toFixed(2);
  //   console.log(price);
  
  //   // Convert to string and remove any existing commas
  //   const cleanPrice = String(price).replace(/,/g, "");
  
  //   // Split by decimal and take just the integer part
  //   const splitPrice = cleanPrice.split(".")[0];
  
  //   // Format the number with Indian style commas (e.g., 1,23,456)
  //   const priceInRupees = new Intl.NumberFormat("en-IN", {
  //     maximumFractionDigits: 0,
  //   }).format(splitPrice);
  
  //   return priceInRupees;
  // };
  
  // function formatMoney(cents, currency = "Rs ") {
  //   return currency + (cents / 100).toFixed(2);
  // }


  container?.addEventListener("click", (event) => {
  const target = event.target;

  if (target.classList.contains("wishlist-add-to-cart")) {
    const variantId = target.getAttribute("data-variant-id");
    wishlistAddToCart(variantId);
  }

  if (
    target.classList.contains("wishlist-remove") ||
    target.closest(".wishlist-remove")
  ) {
    event.preventDefault();      
    event.stopPropagation();     

    const button = target.closest(".wishlist-remove");
    const variantId = button.getAttribute("data-variant-id");
    removeWishlistItem(variantId);
  }
});
  
async function wishlistAddToCart(variantId) {
  const formData = {
    items: [{
      id: Number(variantId),
      quantity: 1
    }]
  };

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) throw new Error("Add to cart failed");

    if (customerId && wishlistId) {
     
      const getRes = await fetch(`https://oms-app.iqrupandritz.com/api/base/wishlists/${wishlistId}/`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "x-shopify-customer-id": customerId,
        },
      });

      if (!getRes.ok) throw new Error(`GET wishlist failed: ${getRes.status}`);
      const result = await getRes.json();
      const wishlistItems = result.wishlist_items || [];

    
      const wishlistName = result.name;
      const updatedItems = wishlistItems.filter(
        (item) => item.product_variant !== Number(variantId)
      );
      
      console.log("updatedItems",updatedItems )
      await fetch(`https://oms-app.iqrupandritz.com/api/base/wishlists/${wishlistId}/`, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "x-shopify-customer-id": customerId,
        },
        body: JSON.stringify({
            name: wishlistName,
            wishlist_items: updatedItems
          })
      });
     window.location.href = '/cart';

    } else {
       const updatedItems = storedItems.filter(
        (item) => item.product_variant !== Number(variantId)
      );
      localStorage.setItem("Wishlist items", JSON.stringify(updatedItems));
       window.location.href = '/cart';
    }

  } catch (error) {
    console.error("Add to cart error:", error);
  }
}

async function removeWishlistItem(variantId) {
  console.log("removeWishlistItem");

  if (customerId && wishlistId) {
  
    try {
      const getRes = await fetch(`https://oms-app.iqrupandritz.com/api/base/wishlists/${wishlistId}/`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "x-shopify-customer-id": customerId,
        },
      });

      if (!getRes.ok) throw new Error(`GET wishlist failed: ${getRes.status}`);
      const result = await getRes.json();
      const wishlistItems = result.wishlist_items || [];
      const wishlistName = result.name;

     
      const updatedItems = wishlistItems.filter(
        (item) => item.product_variant !== Number(variantId)
      );

      console.log("updatedItems", updatedItems);


      await fetch(`https://oms-app.iqrupandritz.com/api/base/wishlists/${wishlistId}/`, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "x-shopify-customer-id": customerId,
        },
        body: JSON.stringify({
          name: wishlistName,
          wishlist_items: updatedItems,
        }),
      });

      window.location.reload();

    } catch (error) {
      console.error("Error removing wishlist item:", error);
    }

  } else {
    
    const updatedItems = storedItems.filter(
      (item) => item.product_variant !== Number(variantId)
    );
    localStorage.setItem("Wishlist items", JSON.stringify(updatedItems));
    window.location.reload(); 
  }
}

  function showSpinner() {
    console.log("spinn");
    if (container) {
         container.innerHTML = `
      <div class="loading_screen">
        <div class="spinner"> </div>
      </div>
    `;
    }
  }
  
  function hideSpinner() {
    console.log("spinn-remove");
    const spinner = container?.querySelector(".loading_screen");
    if (spinner) spinner.remove();
  }
});

